import { Component, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ConnectionService } from './connection.service';
import { ToastrService } from 'ngx-toastr';
import { WalletserviceService } from './services/walletservice.service';
import { LoginComponent } from './pages/login/login.component';
import { HeaderComponent } from './components/header/header.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = '';
  url: any
  previousUrl: any;
  siteDetails: any;
  siteMode: any;

  constructor(private render: Renderer2, private router: Router, private conn: ConnectionService, private alert: ToastrService, private actRoute: ActivatedRoute, private walletService: WalletserviceService, private login: HeaderComponent) {
    this.conn.idleLogout();
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          let currentUrlSlug = event.url.slice(1);
          if (this.previousUrl) {
            this.render.removeClass(document.body, this.previousUrl);
          }
          if (currentUrlSlug) {
            this.render.addClass(document.body, currentUrlSlug);
          }
          this.previousUrl = currentUrlSlug;
        }
      }
    )
    {
      this.router.events.subscribe((evt: any) => {
        let route: any = evt;
        if (route.navigationTrigger == "imperative") {
          window.scrollTo(0, 0);
        }
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
      });
    }
  }

  ngOnInit(): void {
    window.addEventListener('storage', (event: any) => {
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('Sastana_Token');
        if (token == undefined) {
          this.login.logOut();
        }
      }
    });
  }

  getSettings() {
    this.conn.getUrl('admin/settings').subscribe((res: any) => {
      if (res.status == true) {
        this.siteMode = res.data.sitemode
      }
    })
  }
}
